import { EventChannelList, notifyEventChannel } from 'helpers/event-center';

export function openCustomOptionModal(optionGroup: string) {
  notifyEventChannel(EventChannelList.QUOTE_PAGE_OPEN_CUSTOM_OPTION_MODAL, { parent: optionGroup });
}
